import { Button, Image, Table } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { MAIN_URL } from '../../Constants';

function CominHistory(props) {
  let [history, setHistory] = useState([])
  useEffect(() => {
    axios.get('/comin').then(res => {
      setHistory(res.data)
    })
  }, [])

  const columns = [
    {
      title: 'Kirim raqami',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Vaqti',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Kontragent',
      dataIndex: 'suplier',
      key: 'suplier',
      render: (_, rec) => <span>{rec.customername} {rec.customerlastname}<hr />
        <Button href={'tel:' + rec.customermobile} type='primary' style={{ backgroundColor: '#8d2da0ff', border: 'none' }}>{rec.customermobile}</Button>
      </span>
    },
    {
      title: 'Yetkazuvchi',
      dataIndex: 'deliver',
      key: 'deliver',
    },
    {
      title: 'Hujjat raqami',
      dataIndex: 'document',
      key: 'document',
      render: (rec) => <>№ {rec}</>
    },
    {
      title: 'Mashina raqami',
      dataIndex: 'auto',
      key: 'auto',
    },
    {
      title: 'Jami summasi',
      dataIndex: 'summa',
      key: 'summa',
      render: (rec) => <>{rec} $</>
    },
  ];


  return (
    <Table
      columns={columns}
      bordered
      expandable={{
        expandedRowRender: (record) => (
          <Table columns={[
            {
              title: 'Rasmi',
              dataIndex: 'productimg',
              key: 'productimg',
              render: (rec) => <Image src={MAIN_URL + '/' + rec} width={50} />
            },
            {
              title: 'Nomi',
              dataIndex: 'product',
              key: 'name',
            },
            {
              title: 'Soni',
              dataIndex: 'count',
              key: 'count',
              render: (rec) => <>{rec} birlik</>
            },
            {
              title: 'Narxi',
              dataIndex: 'price',
              key: 'price',
              render: (rec) => <>{rec} $</>
            },
            {
              title: 'Summasi',
              dataIndex: 'summa',
              key: 'summa',
              render: (rec) => <>{rec} $</>
            },
            {
              title: "Sheriklik bo'lsa yashil",
              dataIndex: 'sheriklik',
              key: 'sheriklik',
              render: (sh, rec) => <div style={{ padding: '5px', textAlign: 'center', color: '#fff', height: '25px', borderRadius: '25px', backgroundColor: (sh) ? 'green' : 'gray' }}>Qoldiq: {rec.qoldiq}</div>
            }
          ]} dataSource={record.items} rowKey={'id'} />
        ),
        rowExpandable: (record) => record.name !== 'Not Expandable',
      }}
      dataSource={history}
      rowKey='id'
    />
  );
}

export default CominHistory;